import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage, deleteToken } from "firebase/messaging";

const firebaseBapp = initializeApp({
   apiKey: "AIzaSyAccn3HlR0PI6EUfZxZIvsOYzuDu-ECVDE",
   authDomain: "amadaychoob-f85f8.firebaseapp.com",
   projectId: "amadaychoob-f85f8",
   storageBucket: "amadaychoob-f85f8.appspot.com",
   messagingSenderId: "893331414749",
   appId: "1:893331414749:web:6ff724e5412a70b6234534",
   measurementId: "G-MY85P2SDHK",
});

let messaging;
try {
   messaging = getMessaging(firebaseBapp);
} catch (ex) {
   console.log("This browser doesn't support the API's required to use the Firebase SDK. (messaging/unsupported-browser).");
}
// Retrieve firebase messaging

export const checkFirebaseToken = async () => {
   // if (navigator.userAgent.match(/iphone|mac/gim)) {
   //    return;
   // }
   let firebaseToken = localStorage.getItem("listenerId");
   console.log(firebaseToken);
   if (!firebaseToken) {
      let token = await requestForToken();
      if (token) {
         return token;
      } else {
         console.log("cannot get firebase token!");
      }
   }
   return firebaseToken;
};

export const deleteFirebaseTokenFromBrowser = async () => {
   if (messaging) {
      let result = await deleteToken(messaging);
   }
};

export const requestForToken = async () => {
   if (messaging) {
      try {
         let data = await getToken(messaging, {
            vapidKey: "BA7zzctXI-OTrYA2KWXXn4y02NpEEohxrkJ5cKaRZWXUh17S5WN4iqe3cm0F9WSzqi-_XByl2NZgLJQSCeQZjts",
         });
         return data;
      } catch (ex) {
         console.log("Vap Exception: ", ex?.message);
      }
   }
};

onMessage(messaging, (payload) => {
   const receiveNotification = new CustomEvent("onReceiveNotification", {
      bubbles: true,
      cancelable: true,
      composed: false,
      detail: { ...payload?.data },
   });

   window.dispatchEvent(receiveNotification);
});

/* eslint-disable no-restricted-globals */
